import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from './pages/Home';
import Checkin from './pages/Checkin';
import Presentation from './pages/Presentation';
import Attending from './pages/Attending';
import AllPresentations from './pages/AllPresentations';
import PresenterDemo from './pages/PresenterDemo';
import Presenter from './pages/Presenter';
import Presented from './pages/Presented';
import Upload from './pages/Upload';
import SignInUser from './pages/SignInUser';
import StartPresentation from './pages/StartPresentation';
import ViewPresentation from './pages/ViewPresentation';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/checkin',
    component: Checkin
  },
  {
    path: '/presentations',
    component: AllPresentations
  },
  {
    path: '/present',
    name: 'present',
    component: PresenterDemo
  },
  {
    path: '/presented/:presentationId',
    name: 'presented',
    component: Presented
  },
  {
    path: '/presentation/:presentationId',
    name: 'presentation',
    component: Presentation
  },
  {
    path: '/attend/:presentationId',
    name: 'attending',
    component: Attending
  },
  {
    path: '/upload/:presentationId',
    name: 'upload',
    component: Upload
  },
  {
    path: '/sign-in-user',
    name: 'sign-in-user',
    component: SignInUser
  },
  {
    path: '/presenter',
    name: 'presenter',
    component: Presenter
  },
  {
    path: '/presenter/view/:presentationId',
    name: 'view-presentation',
    component: ViewPresentation
  },
  {
    path: '/presenter/start',
    name: 'start-presentation',
    component: StartPresentation
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js